"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgSort = function SvgSort(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M271 923.6V406.88a28.45 28.45 0 0156.89 0v516.73L436.3 807.94a28.42 28.42 0 0141.48 38.85L320.25 1015a28.46 28.46 0 01-41.53 0L121.2 846.79a28.43 28.43 0 0141.53-38.85zm424.5-823.17L587.17 216.11a28.44 28.44 0 01-41.48-38.92L702.57 9.72a28.44 28.44 0 0142.82 0l156.88 167.47a28.46 28.46 0 01-41.53 38.92L752.42 100.45v516.67a28.44 28.44 0 11-56.88 0z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgSort, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;